import { render } from "./CompetitionsView.vue?vue&type=template&id=161d7c0a&scoped=true"
import script from "./CompetitionsView.vue?vue&type=script&lang=js"
export * from "./CompetitionsView.vue?vue&type=script&lang=js"

import "./CompetitionsView.vue?vue&type=style&index=0&id=161d7c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161d7c0a"]])

export default __exports__